import Icon from 'veui/components/Icon'

Icon.register({
  loading: {
    paths: [
      {
        d: 'M48 24a2 2 0 11-4 0A20 20 0 0024 4a2 2 0 110-4 24 24 0 0124 24z'
      }
    ],
    width: '48',
    height: '48'
  }
})
